import axios from 'axios';

export default class PermissionsService
{
    public static async getList()
    {
        return (await axios.get<PermissionsGroup[]>('admin/permissions')).data;
    }

    public static async checkPermissions(permissions: string[])
    {
        return (await axios.post<Record<string, boolean>>('admin/permissions', {
            permissions: permissions
        })).data;
    }

    public static async inspect(id: number)
    {
        return (await axios.get<KeyValue<string, Record<string, string>>[]>(`admin/permissions/inspect/${id}`)).data;
    }

    public static async getIdentities(query: string, searchUsers?: boolean, searchRoles?: boolean, searchTeams?: boolean)
    {
        return (await axios.get<PersonasGroup[]>('admin/permissions/personas', {
            params: {
                query: query,
                searchUsers: searchUsers,
                searchRoles: searchRoles,
                searchTeams: searchTeams
            }
        })).data;
    }

    public static async resourcePermissions(resource: string)
    {
        return (await axios.get<PermissionsGroup>(`admin/permissions/resource/${resource}`)).data;
    }

    public static async saveResourcePermissions(resourceType: string, resourceId: number, model: ResourcePermissionsModel)
    {
        return (await axios.put<Statement>(`admin/permissions/resource/${resourceType}/${resourceId}`, model)).data;
    }

    public static async resourceOwners(resourceType: string, resourceId: number)
    {
        return (await axios.get<ResourceOwner[]>(`admin/permissions/resource/${resourceType}/${resourceId}`)).data;
    }
}

export enum PermissionType
{
    Access = 0,
    Resource = 1,
    All = 2
}

export interface PermissionsGroup
{
    key: string;
    name: string;
    sections: KeyValue<string, PermissionDescriptor>[][];
}

export interface PermissionDescriptor
{
    description: string;
    type: PermissionType;
    alt: string;
}

export interface PersonasGroup
{
    group: string;
    type: string;
    values: KeyValue<number, string>[];
}

export enum PermissionStateEnum
{
    Allow = 'Allow',
    Deny = 'Deny'
}

export interface ResourcePermissionsModel
{
    ownerId: number;
    ownerType: string;
    permissionsType: string;
    permissions: Record<string, PermissionStateEnum>;
}

export interface ResourceOwner
{
    ownerId: number;
    ownerType: string;
    ownerName: string;
    permissions: Record<string, PermissionStateEnum>;
}
